enum Path {
  ROOT = '/',
  DASHBOARD = '/dashboard',
  BRN = '/brain',
  MARKET = '/market',
  MARKET_DETAILS = '/market/:brTokenId',
  TRANSACTION = '/transaction',
  HISTORY = '/history',
  FARM = '/farm',
  VOTE = '/vote',
  VOTE_LEADER_BOARD = '/vote/leaderboard',
  VOTE_PROPOSAL_DETAILS = '/vote/proposal/:id',
  VOTE_ADDRESS = '/vote/address/:address',
  FAUCET = '/faucet',
  NFTMARKET = '/nft'
}

export default Path;
